import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class UrlQueryService {

  constructor() { }

  public static addQueryParameters(uri: string, parameters: any): string {
    let query;

    if (parameters) {
      if (_.isNumber(parameters.page) && !parameters.cursor) {
        query = this.getQueryPrefix(query) + 'page=' + parameters.page;
      }

      if (_.isNumber(parameters.limit)) {
        query = this.getQueryPrefix(query) + 'limit=' + parameters.limit;
      }

      if (_.isString(parameters.sort)) {
        query = this.getQueryPrefix(query) + 'sort=' + parameters.sort;
      }

      if (parameters.filter) {
        const filterQuery = this.buildFilterQuery(parameters.filter);

        if (filterQuery) {
          query = this.getQueryPrefix(query) + 'filter=' + filterQuery;
        }
      }

      if (parameters.cursor && parameters.cursor.page && parameters.cursor.page !== 1) {
        query = this.getQueryPrefix(query) + `${parameters.cursor.direction}=${parameters.cursor[parameters.cursor.direction]}`;
      }

      if (_.isBoolean(parameters.enclose) && parameters.enclose) {
        query = this.getQueryPrefix(query) + 'enclose=' + parameters.enclose;
      }
    }

    return query ? (uri + query) : uri;
  }

  public static restructureFilterParams(parameters): string {
    let filter: any = {};
    if (parameters) {
      if (parameters.searchObject) {
        if (typeof parameters.searchObject === 'string') {
          filter = {
            searchString: {
              operator: ':',
              value: parameters.searchObject
            }
          };
          parameters.searchObject = undefined;
          parameters.filter = filter;
        } else {
          parameters.filter = parameters.searchObject;
          parameters.searchObject = undefined;
        }
      }
    }
    return parameters;
  }

  private static getQueryPrefix(query): string {
    return (query ? (query + '&') : '?');
  }

  private static buildFilterQuery(filter): string {
    const filterArr: any = [];

    for (const term in filter) {
      if (filter[term] && !_.isNil(filter[term].value) && (filter[term].value !== '')) {
        let value = filter[term].value;
        let operator = filter[term].operator;

        value = Array.isArray(value) ? value.join(';') : value;
        value = typeof value === 'string' ? encodeURIComponent(value) : value;
        operator = operator === ':' ? '~' : '=';
        filterArr.push(term + operator + value);
      }
    }
    if (filterArr.length === 0) {
      return null;
    }

    return '(' + filterArr.join(',') + ')';
  }
}
